module.exports = __webpack_public_path__ + "img/lockscreen.df1e79aa.png";